const Menu = function(){

    
    const scrollHeader = function (el) {

        let headerH = $(el).height();
        if( $(window).scrollTop() >  headerH * 2){
            if(!$(el).hasClass('opened'))
            {
                $("#webdoor-start").addClass('upWebdoor');
                $(el).addClass('scrolling');
            }
        } else{
            $("#webdoor-start").removeClass('upWebdoor');
            $(el).removeClass('scrolling');
        }
    }

    const toggleMenu = function (el) {

        var layerMenu = $("#layer-menu");

        //hide search
        $("#call-search").toggle();

        $(el).toggleClass("motion-in");
        $(el).closest('header').toggleClass("header-opened").find('nav').toggleClass("motion-in");
        layerMenu.toggleClass("motion-in");

        if(layerMenu.hasClass("motion-in")){
            $('html,body').addClass('no-scroll');
        }else{
            $('html,body').removeClass('no-scroll');
        }

    }

    const toggleAccordionMob = function (el)
    {
        $('.wrap-ul-exp').find('>ul').slideUp(25);
        if($(el).closest('.wrap-ul-exp').find('>ul').is(":visible")){
            $(el).closest('.wrap-ul-exp').find('>ul').slideUp(25);
        }else{
            $(el).closest('.wrap-ul-exp').find('>ul').slideDown(25);
        }
    }

    const hoverRegions = () => {
        var _h_indexReg = '';
        $("#wrap-regions-hover p").on('mouseenter',function(){

            $(`#wrap-regions-hover img,#wrap-regions-hover p`).removeClass('hovered')
            _h_indexReg = $(this).attr('data-index');
            $(this).addClass('hovered');
            $(`#wrap-regions-hover img[data-index=${_h_indexReg}]`).addClass('hovered')

        }).on('mouseleave', function(){
        })
    }

    return {
        init : function () {

            scrollHeader("#header");

            $(window).on('scroll', function(){
                scrollHeader("#header");
            });

            $("#wrap-sandwitch").on("click", function(){
                toggleMenu(this);
            });
            
            if( $(window).width() <= 768 ){
                $(".toggle-mob").on("click", function(){
                    toggleAccordionMob(this);
                });
            }

            if($("#wrap-regions-hover").length >0){
                hoverRegions();
            }
        }
    }

}();

module.exports = Menu;